<template>
  <div 
    class="mt-8">
    <v-layout wrap>
      <v-flex>
        <section>

          <v-card 
            flat
            class="ma-4 mt-0 pa-5 box-shadow pb-5"
            style="border-radius: 10px;">
            <v-row>
              <v-col cols="6" class="py-0">
                <div class="color-dark-blue fs-22 font-weight-bold">
                  Tambahkan Surat Jalan
                </div>
              </v-col>
            </v-row>
            
            <v-row
              class="">
              <v-col cols="12" class="pb-0 pt-1">
                <v-row>
                  <v-col cols="6" class="py-2" v-if="$store.state.user.category_user_title !== 'Supervisor'">
                    <div v-if="$store.state.user.category_user_title !== 'Supervisor'">
                      <v-autocomplete
                        v-model="filterDataSupervisor"
                        :items="supervisor"
                        item-text="name"
                        item-value="id"
                        clearable
                        @click:clear="filterDataSupervisor = ''; fetchOrder();"
                        hide-details
                        @change="fetchOrder()"
                        filled
                        rounded
                        dense
                        class="fs-12 little-placeholder"

                        color="#718EBF"
                        placeholder="Nama Supervisor"

                        
                        :item-color="set_color"
                        style="border-radius: 6px; background: #d9e8ff9c !important;">
                        <template v-slot:item="data">
                          <template>
                            <v-list-item-content class="fs-12">{{ data.item.name }}</v-list-item-content>
                          </template>
                        </template>

                      </v-autocomplete>
                    </div>
                  </v-col>
                  <v-col cols="6" class="py-2">
                    <v-autocomplete
                      v-model="filterDataSales"
                      :items="sales"
                      item-text="name"
                      item-value="name"
                      clearable
                      @click:clear="filterDataSales = ''; fetchOrder();"
                      hide-details
                      @change="fetchOrder()"
                      filled
                      rounded
                      dense
                      class="fs-12 little-placeholder"

                      color="#718EBF"
                      placeholder="Nama Sales"

                      
                      :item-color="set_color"
                      style="border-radius: 6px; background: #d9e8ff9c !important;">
                      <!-- <template v-slot:selection="{ item }">
                        <v-chip
                          v-if="item"
                          label
                          close
                          @click:close="filterDataSales = null">
                          {{ item.name }}
                        </v-chip>
                      </template> -->
                      <template v-slot:item="data">
                        <template>
                          <v-list-item-content class="fs-12">{{ data.item.name }}</v-list-item-content>
                        </template>
                      </template>

                    </v-autocomplete>
                  </v-col>
                  <v-col cols="3" class="py-0">
                    <ValidationProvider
                      name="Provinsi" 
                      rules="" 
                      v-slot="{ errors }">
  
                      <v-autocomplete
                        v-on:keyup.enter="save()"
                        
                        v-on:change="changeProvince()"
                        @click:clear="form.province_name = ''; changeProvince();"
                        clearable
                        filled
                        rounded
                        dense
                        class="fs-12 little-placeholder"

                        color="#718EBF"
                        hide-details
  
                        placeholder="Provinsi"
  
                        :items="province"
                        item-value="name"
                        item-text="name"
                        :item-color="set_color"
  
                        v-model="form.province_name"
                        :error-messages="errors"
                        
                        style="border-radius: 6px; background: #d9e8ff9c !important;">
                      </v-autocomplete>
                    </ValidationProvider>
  
                  </v-col>
                  <v-col cols="3" class="py-0">
                    <ValidationProvider
                      name="Kota/ Kabpaten" 
                      rules="" 
                      v-slot="{ errors }">
  
                      <v-autocomplete
                        v-on:keyup.enter="save()"
                        
                        clearable
                        filled
                        rounded
                        dense
                        class="fs-12 little-placeholder"

                        color="#718EBF"
                        hide-details
  
                        v-on:change="changeCity()"
                        @click:clear="form.city_name = ''; changeCity();"
                        placeholder="Kota/ Kabpaten"
  
                        :items="city"
                        item-value="name"
                        item-text="name"
                        :item-color="set_color"
  
                        v-model="form.city_name"
                        :error-messages="errors"
                        
                        style="border-radius: 6px; background: #d9e8ff9c !important;">
                      </v-autocomplete>
                    </ValidationProvider>
  
                  </v-col>
                  <v-col cols="3" class="py-0">
                    <ValidationProvider
                      name="Kecamatan" 
                      rules="" 
                      v-slot="{ errors }">
  
                      <v-autocomplete
                        v-on:keyup.enter="save()"
                        
                        clearable
                        filled
                        rounded
                        dense
                        class="fs-12 little-placeholder"

                        color="#718EBF"
                        hide-details
  
                        v-on:change="changeSubdistrict()"
                        @click:clear="form.subdistrict_name = ''; changeSubdistrict();"
                        placeholder="Kecamatan"
  
                        :items="subdistrict"
                        item-value="name"
                        item-text="name"
                        :item-color="set_color"
  
                        v-model="form.subdistrict_name"
                        :error-messages="errors"
                        
                        style="border-radius: 6px; background: #d9e8ff9c !important;">
                      </v-autocomplete>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="3" class="py-0">
                    <ValidationProvider
                      name="Kelurahan" 
                      rules="" 
                      v-slot="{ errors }">
  
                      <v-autocomplete
                        v-on:keyup.enter="save()"
                        
                        clearable
                        filled
                        rounded
                        dense
                        class="fs-12 little-placeholder"

                        color="#718EBF"
                        hide-details
  
                        v-on:change="changeVillage()"
                        @click:clear="form.village_name = ''; changeVillage();"
                        placeholder="Kelurahan"
  
                        :items="village"
                        item-value="name"
                        item-text="name"
                        :item-color="set_color"
  
                        v-model="form.village_name"
                        :error-messages="errors"
                        
                        style="border-radius: 6px; background: #d9e8ff9c !important;">
                      </v-autocomplete>
                    </ValidationProvider>
                  </v-col>
                </v-row>
  
              </v-col>
              <v-col 
                cols="12"
                class="px-0">
                <v-card 
                  flat
                  style="background: transparent;">
                  <v-card-text class="pt-1">
                    <ValidationObserver 
                      ref="form">
                      <v-form>
                        <!-- <div
                          class="mb-4">
                          <div 
                            class="body-2 mb-2">
                            Poto Profil
                          </div>
  
                          <uploadfolder v-if="form.image_url === ''"
                            v-model="upload.image">
                            <div 
                              slot="activator">
                              <v-card 
                                flat
                                width="200"
                                height="200"
                                class="d-flex align-center justify-center cursor-pointer"
                                style="border-radius: 15px;
                                      border: 2px solid #EBEBEB; 
                                      border-style: dashed;">
                                <v-avatar v-if="!process.image"
                                  v-ripple
                                  tile 
                                  width="200"
                                  height="200">
                                  <v-icon
                                    size="50"
                                    color="#B9B9B9">
                                    mdi-cloud-upload-outline
                                  </v-icon>
                                </v-avatar>
  
                                <v-progress-circular v-else
                                  indeterminate
                                  :color="set_color">
                                </v-progress-circular>
                              </v-card>
                            </div>
                          </uploadfolder>
  
                          <v-card v-if="form.image_url !== ''"
                            flat
                            width="200"
                            height="200"
                            class="d-flex align-center justify-center"
                            style="border-radius: 15px;
                                  border: 2px solid #EBEBEB; 
                                  border-style: dashed;">
                            <v-avatar
                              v-ripple
                              tile 
                              size="200"
                              style="border-radius: 15px;">
                              <v-img 
                                contain
                                width="100%"
                                height="100%"
                                alt="Mitra Warung" 
                                :src="form.image_url"
                                class="ma-auto"
                                style="border-radius: 15px;">
                                <template v-slot:placeholder>
                                  <v-row
                                    class="fill-height"
                                    align="center"
                                    justify="center">
                                    <v-progress-circular 
                                      indeterminate 
                                      :color="set_color">
                                    </v-progress-circular>
                                  </v-row>
                                </template>
                              </v-img>
                            </v-avatar>
  
                            <v-icon 
                              @click="form.image_url = ''"
                              color="red"
                              class="cursor-pointer"
                              style="position: absolute; top: -10px; right: -10px;">
                              mdi-close-circle
                            </v-icon>
                          </v-card>
                        </div> -->
  
                        <v-row>
                          <v-col
                            cols="12"
                            md="6" class="pt-0">
  
                            <!-- <ValidationProvider
                              name="No surat jalan" 
                              rules="required" 
                              v-slot="{ errors }">
                              <div 
                                class="fs-15 label-input">
                                No surat jalan
                              </div>
        
                              <v-autocomplete
                                v-on:keydown.enter.prevent="save()"
                                
                                filled
                                rounded
                                dense
                                solo
        
                                color="#718EBF"
                                placeholder="No surat jalan"
        
                                
                                :items="pembelian"
                                item-value="id"
                                item-text="number"
                                :item-color="set_color"
        
                                v-model="form.no_surat_jalan"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                              </v-autocomplete>
                            </ValidationProvider> -->
  
  
  
                            <ValidationProvider
                              name="Nama Driver" 
                              rules="required" 
                              v-slot="{ errors }">
                              <div 
                                class="fs-15 label-input">
                                <!-- <span class="red--text">*</span> -->
                                Nama Driver
                              </div>
        
                              <v-autocomplete
                                v-on:keydown.enter.prevent="save()"
                                
                                filled
                                rounded
                                dense
                                solo
        
                                color="#718EBF"
                                placeholder="Nama Driver"
        
                                
                                :items="driver"
                                item-value="id"
                                item-text="name"
                                :item-color="set_color"
        
                                v-model="form.driver_id"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                              </v-autocomplete>
                            </ValidationProvider>
  
                            <div class="fs-15 label-input">
                            <!-- <span class="red--text">*</span> -->
                            
                              Tanggal kirim
                            </div>
              
                            <v-menu
                              v-model="menu2"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                              >
                              <template v-slot:activator="{ on, attrs }">
                                <ValidationProvider 
                                  name="Tanggal Kirim" 
                                  rules="required" 
                                  v-slot="{ errors }">
                                  <v-text-field
                                    v-model="form.date"
                                    
                                    v-on:keyup.enter="save()"
                                    
                                    filled
                                    solo
                                    rounded
                                    dense
                                    
                                    :color="set_color"
                                    placeholder="Tanggal Kirim"
              
                                    :disabled="Object.keys(form).length < 1"
              
                                  
              
                                    :error-messages="errors"
                                    required
                                    style="border-radius: 10px;"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    >
                                  </v-text-field>
                                </ValidationProvider>
                              </template>
                              <v-date-picker
                                v-model="form.date"
                                :min="new Date().toISOString().substr(0, 10)"
                                @input="menu2 = false"
                              ></v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col
                            cols="12"
                            md="6" class="pt-0">
                            <!-- <ValidationProvider
                              name="No BPB" 
                              rules="required" 
                              v-slot="{ errors }">
                              <div 
                                class="fs-15 label-input">
                                No BPB
                              </div>
        
                              <v-autocomplete
                                v-on:keydown.enter.prevent="save()"
                                
                                filled
                                rounded
                                dense
                                solo
        
                                color="#718EBF"
                                placeholder="No BPB"
        
                                
                                :items="pembelian"
                                item-value="id"
                                item-text="number"
                                :item-color="set_color"
        
                                v-model="form.no_bpb"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                              </v-autocomplete>
                            </ValidationProvider> -->
  
                            <ValidationProvider
                              name="Nama Vehicle" 
                              rules="required" 
                              v-slot="{ errors }">
                              <div 
                                class="fs-15 label-input">
                                <!-- <span class="red--text">*</span> -->
                                Nama Vehicle
                              </div>
        
                              <v-autocomplete
                                v-on:keydown.enter.prevent="save()"
                                
                                filled
                                rounded
                                dense
                                solo
        
                                color="#718EBF"
                                placeholder="Nama Vehicle"
        
                                
                                :items="vehicle"
                                item-value="id"
                                :item-text="item => `${item.name} - ${item.number}`"
                                :item-color="set_color"
        
                                v-model="form.vehicle_id"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:selection="{ item }">
                                  <div
                                    v-if="item" style="">
                                    {{ item.name }} - {{ item.number }}
                                  </div>
                                </template>
                                <template v-slot:item="{ item }">
                                  <v-list-item-content>
                                    <v-list-item-title>{{ item.name }} - {{ item.number }}</v-list-item-title>
                                  </v-list-item-content>
                                </template>
                              </v-autocomplete>
                            </ValidationProvider>
  
                          </v-col>
                          <v-col cols="12">
                            <div 
                              class="fs-15 label-input">
                              <!-- <span class="red--text">*</span> -->
                              Catatan
                            </div>
        
                            <v-textarea
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#718EBF"
                              placeholder="Catatan"
                              row="3"
        
                              
        
                              v-model="form.note"
                              style="border-radius: 10px;">
                            </v-textarea>
                          </v-col>
  
                          <v-col
                            cols="12"
                            md="12" class="pt-0">
  
                            <!-- <ValidationProvider
                              name="No Order" 
                              rules="required" 
                              v-slot="{ errors }">
                              <div 
                                class="fs-15 label-input">
                                No BPB
                              </div>
        
                              <v-autocomplete
                                v-on:keydown.enter.prevent="save()"
                                
                                filled
                                rounded
                                dense
                                solo
        
                                color="#718EBF"
                                placeholder="No BPB"
                                v-on:change="changeOrder()"
                                multiple
        
                                
                                :items="order"
                                item-value="id"
                                item-text="number"
                                :item-color="set_color"
        
                                v-model="form.bpb_arr"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                              </v-autocomplete>
                            </ValidationProvider> -->

                            <div 
                              class="fs-15 label-input mb-3">
                              No BPB
                            </div>

                            <div v-if="!process.load">
                              <table style="border: 1px solid #ededed; width: 100%; border-collapse: collapse;">
                                <tr>
                                  <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                                    Aksi
                                  </th>
                                  <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left;" class="black--text">
                                    No BPB
                                  </th>
                                  <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left;" class="black--text">
                                    No Sales Order
                                  </th>
                                  <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left;" class="black--text">
                                    Tgl Order
                                  </th>
                                  <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left;" class="black--text">
                                    Nama Toko
                                  </th>
                                  <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left;" class="black--text">
                                    Alamat
                                  </th>
                                  <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left;" class="black--text">
                                    Nama Sales
                                  </th>
                                  <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left;" class="black--text">
                                    Item Order
                                  </th>
                                </tr>
                                <tr v-for="(item, index) in order" :key="index">
                                  <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                                    <v-checkbox
                                      v-model="form.bpb_arr"
                                      :value="item.id"
                                    ></v-checkbox>
                                  </td>
                                  <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 1px; white-space: nowrap;" class="black--text">
                                    {{ item.number }}
                                  </td>
                                  <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 1px; white-space: nowrap;" class="black--text">
                                    {{ item.order_number }}
                                  </td>
                                  <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 1px; white-space: nowrap;" class="black--text">
                                    {{ item.order_input_datetime | datetime }}
                                  </td>
                                  <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 1px; white-space: nowrap;" class="black--text">
                                    {{ item.store_name }}
                                  </td>
                                  <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left;" class="black--text">
                                    {{ item.customer_shipping_province }}, {{ item.customer_shipping_city }}, {{ item.customer_shipping_subdistrict }}, {{ item.customer_shipping_village }}
                                  </td>
                                  <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 1px; white-space: nowrap;" class="black--text">
                                    {{ item.sales_name }}
                                  </td>
                                  <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 1px; white-space: nowrap;" class="black--text">
                                    <div v-for="(items, indexs) in item.bpb_detail" :key="indexs">
                                        {{ items.bpb_detail_varian_name }} - <span>
                                        <span v-if="items.bpb_detail_qty_pcs*1 > 0">
                                          {{ items.bpb_detail_qty_pcs }} Pcs
                                        </span>
                                        <span v-if="items.bpb_detail_qty_lusin*1 > 0">
                                          {{ items.bpb_detail_qty_lusin }} Lusin
                                        </span>
                                        <span v-if="items.bpb_detail_qty_dus*1 > 0">
                                          {{ items.bpb_detail_qty_dus }} {{ (item.detail[indexs].orders_detail_total_in_dus*1) > 1 ? 'Dus' : 'Pcs' }}
                                        </span>
                                      </span>
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </div>

                            <v-card-text
                              v-if="process.load" 
                              class="pb-0 my-4" 
                              style="height: 300px; display: flex; align-items: center; justify-content: center;">
                              <div class="text-center">
                                <div class="mb-4 title">
                                  Mohon Tunggu . . .
                                </div>

                                <v-progress-linear
                                  :color="set_color"
                                  indeterminate
                                  rounded
                                  height="10">
                                </v-progress-linear>
                              </div>
                            </v-card-text>

                            <v-card-text
                              v-if="!process.load && order.length === 0"
                              class="pb-0 my-4" style="height: 300px; display: flex; align-items: center; justify-content: center;">
                              <div class="text-center">
                                <v-img 
                                  class="mx-auto"
                                  contain
                                  alt="vuetify"
                                  :width="90"
                                  :height="90"
                                  :src="require('@/assets/image/empty.png')">
                                  <!-- <template v-slot:placeholder>
                                    <v-row
                                      class=" "
                                      align="center"
                                      justify="center">
                                      <v-progress-circular 
                                        indeterminate 
                                        :color="set_color">
                                      </v-progress-circular>
                                    </v-row>
                                  </template> -->
                                </v-img>
                                <div class="mt-3 fs-16">
                                  Belum Ada Data
                                </div>
                              </div>
                            </v-card-text>
                          </v-col>
                          
                          
                        </v-row>
  
                        <!-- <v-card flat style="border-radius: 25px; border: 1px solid #E7E7E7;" class="mt-6 mb-5">
                          <v-card-text>
                            <div class="fs-18 input-label font-weight-bold py-2">
                              Detail BPB
                            </div>
                          </v-card-text>
                        </v-card>
  
                        <v-card flat style="border-radius: 25px; border: 1px solid #E7E7E7;" class="pb-7 mt-6 mb-5"  v-for="(items, indexs) in varian_arr" :key="indexs">
                            <v-card-text>
                              <div class="fs-18 input-label mb-8 font-weight-bold pt-2">
                                No. BPB: {{ items[0].bpb_number }}
                              </div>
                              <table width="100%" style="border: thin solid #E6EFF5;">
                                <thead>
                                  <tr>
                                    <th class="text-left fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">Nama Barang</th>
                                    <th class="text-left fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">No. SKU</th>
                                    <th class="text-left fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">Qty yang akan dikirim</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(item, index) in items" :key="index">
                                    <td class="text-left label-input fs-14 pa-2" style="border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">{{ item.varian_name }}</td>
                                    <td class="text-left label-input fs-14 pa-2" style="border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">{{ item.varian_sku }}</td>
                                    <td class="text-left label-input fs-14 pa-2" style="border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">
                                      <div v-if="item.qty_pcs*1 > 0">
                                        {{ item.qty_pcs }} Pcs
                                      </div>
                                      <div v-if="item.qty_lusin*1 > 0">
                                        {{ item.qty_lusin }} Lusin
                                      </div>
                                      <div v-if="item.qty_dus*1 > 0">
                                        {{ item.qty_dus }} Dus
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
  
                          </v-card-text>
                        </v-card> -->
                      </v-form>
                    </ValidationObserver>
  
  
  
                    <div v-if="message.error.length > 0"
                      class="text-center my-4 d-flex align-center">
                      <div
                        class="error--text">
                        <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                        
                        <span
                          class="ml-1">
                          {{ message.error }}
                        </span>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
  
            <v-row
              justify="end"
              class="pa-4 pt-0 pr-1">
              <v-col 
                cols="12"
                md="12"
                class="d-flex align-center justify-end py-0">
                <v-btn 
                  @click="save()"
                  :loading="process.form"
                  :disabled="process.form"
                  width="190"
                  height="45"
                  elevation="0"
                  color="#1814F3"
                  class="fs-16 white--text text-capitalize border-radius">
                  Simpan
                </v-btn>
                
                <v-btn
                  to="/delivery/surat-jalan"
                  :disabled="process.form"
                  color="red"
                  elevation="0"
                  width="140"
                  height="45"
                  class="body-2 white--text text-capitalize d-flex align-center ml-4 border-radius"
                  style="font-weight: 600;">
                
                    Batal
                </v-btn>
              </v-col>
            </v-row>
          </v-card> 
          
          
        </section>
      </v-flex>
    </v-layout>

    <!-- Floating AI Help Button -->
    <v-btn
      fab
      fixed
      bottom
      right
      color="#1814F3"
      elevation="4"
      :style="{ bottom: '24px', right: '24px' }"
      @click="$router.push('/delivery/surat-jalan/add-ai')"
      class="white--text">
      <v-icon>mdi-robot</v-icon>
      <span class="ml-2 fs-12">AI</span>
    </v-btn>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        menu: {
          
        },
        category: [
          {
            title: 'Parsial',
            id: 'Parsial'
          },
          {
            title: 'Full',
            id: 'Full'
          }
        ],
        modal: false,
        menu2: false,

        dialog: {
          customer: false,
          fullscreen: false
        },
        filterDataSupervisor: '',
        filterDataSales: '',
        supervisor: [],
        bukti: 'gambar',
        gambar_url: '',
        pdf_url: '',
        category: ['Gambar', 'Pdf'],
        pembelian: [],
        product_id: '',
        selected: [],
        headers: [],
        list: [],
        supplier: [],
        form: {
          date: '',
          driver_id: '',
          note: '',
          vehicle_id: '',
          province_name: '',
          city_name: '',
          subdistrict_name: '',
          village_name: '',
          // order_id: '',
          bpb_arr: [],
          varian_arr: [],
          // category: '',
          // image_url: '',
          // pdf_url: ''
        },
        varian_arr: [],
        vehicle: [],
        driver: [],
        order: [],
        headers_data: [],
        supervisor: [],
        branch: [],
        province: [],
        city: [],
        subdistrict: [],
        village: [],
        salesAll: [],
        sales: [],

        mobilephone: {
          name: '',
          id: ''
        },

        lastIndex: 1,

        upload: {
          pdf_url: null,
          image_url: null
        },

        process: {
          form: false,

          pdf_url: false,

          image_url: false,
          load: false
        },
        
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue'),
      uploaddocument: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/document.vue')
    },
    watch: {
      'upload.pdf_url': {
        handler: function () {
          if (this.upload.pdf_url) {
            this.process.pdf_url = this.upload.pdf_url.process

            if (!this.process.pdf_url) {
              // CALLBACK FROM UPLOAD IMAGE
              
              this.pdf_url = this.upload.pdf_url.fileuri

              // this.save_image()
            }
          }
        },
        deep: true
      },

      'upload.image_url': {
        handler: function () {
          if (this.upload.image_url) {
            this.process.image_url = this.upload.image_url.process

            if (!this.process.image_url) {
              // CALLBACK FROM UPLOAD IMAGE
              
              this.gambar_url = this.upload.image_url.fileuri

              // this.save_image()
            }
          }
        },
        deep: true
      }
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },
      configHeaders () {
          return this.headers_data.filter(header => !header.hide)  
        },
    },
    mounted () {
      this.fetchSupervisor()
      this.fetchSales()
      this.fetchVehicle()
      this.fetchOrder()
      this.fetchDriver()
      this.fetchProv()
    },
    methods: {
      async fetchSales () {
        this.process.load = true

        let params = {
          'category_user_id[eq]': '8',
          limit: 1000000,
          is_active: 'Aktif',
          spv_id: this.$store.state.user.category_user_title === 'Supervisor' ? this.$store.state.user.id : '',
          // limit: 1000000,
          // par_id: '1'
        }

        await get(`admin/user/data`, { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.sales = res.results.data
            this.salesAll = res.results.data
            if(this.filterDataSupervisor !== '' && this.filterDataSupervisor !== null && this.filterDataSupervisor !== undefined) {
              this.sales = this.salesAll.filter(sales => sales.spv_id === this.filterDataSupervisor)
            }
          }
          this.process.load = false
        })
      },
      async fetchSupervisor () {
        // this.process.load = true

        let params = {
          'category_user_id[eq]': '5',
          limit: 1000000,
          is_active: 'Aktif',
          // limit: 1000000,
          // par_id: '1'
        }

        await get(`admin/user/data`, { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.supervisor = res.results.data
            
          }
          // this.process.load = false
        })
      },
      async fetchProv() {

         let params = {
          limit: 10000000000000
        }

        await get(`ref/provinsi`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.province = res.results.data
          }
        })
      },

      changeProvince() {
        this.form.city_name = ''
        this.form.subdistrict_name = ''
        this.form.village_name = ''
        let id = ''
        this.province.map(obj => {
          if (obj.name === this.form.province_name) {
            id = obj.id
          }
        })
        this.fetchOrder()
        this.fetchCity(id)
      },

      async fetchCity(id) {

         let params = {
          limit: 10000000000000,
          province_id: id
        }

        await get(`ref/kota`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.city = res.results.data
          }
        })
      },
      changeCity() {
        this.form.subdistrict_name = ''
        this.form.village_name = ''
        let id = ''
        this.city.map(obj => {
          if (obj.name === this.form.city_name) {
            id = obj.id
          }
        })
        this.fetchOrder()
        this.fetchSub(id)
      },
      // changeCity() {
      //   this.form.subdistrict_name = ''
      //   let id = ''
      //   this.city.map(obj => {
      //     if (obj.name === this.form.city_name) {
      //       id = obj.id
      //     }
      //   })
      //   this.fetchSub(id)
      // },

      async fetchSub(id) {

         let params = {
          limit: 10000000000000,
          city_id: id
        }

        await get(`ref/kecamatan`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.subdistrict = res.results.data
          }
        })
      },

      changeSubdistrict() {
        this.form.village_name = ''
        let id = ''
        this.subdistrict.map(obj => {
          if (obj.name === this.form.subdistrict_name) {
            id = obj.id
          }
        })
        this.fetchOrder()
        this.fetchVil(id)
      },

      async fetchVil(id) {

         let params = {
          limit: 10000000000000,
          subdistrict_id: id
        }

        await get(`ref/kelurahan`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.village = res.results.data
          }
        })
      },
      changeVillage() {
        this.fetchOrder()
      },
      async fetchOrder () {
        this.form.bpb_arr = []
        this.process.load = true

        let params = {
          limit: 1000000,
          is_delivery: '0',
          customer_shipping_province: this.form.province_name,
          customer_shipping_city: this.form.city_name,
          customer_shipping_subdistrict: this.form.subdistrict_name,
          customer_shipping_village: this.form.village_name,
          spv_id: this.$store.state.user.category_user_title === 'Supervisor' ? this.$store.state.user.id : this.filterDataSupervisor,
          sales_name: this.filterDataSales
          // status: 'persiapan'
          // limit: 1000000,
          // par_id: '1'
        }

        await get(`admin/bpb/data`, { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.pembelian = res.results.data
            this.order = res.results.data
            
          }
          this.process.load = false
        })
      },
      async fetchVehicle () {
        // this.process.load = true

        let params = {
          limit: 10000000,
          // limit: 1000000,
          // par_id: '1'
        }

        await get(`admin/vehicle/data`, { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.vehicle = res.results.data
            
          }
          // this.process.load = false
        })
      },
      async fetchDriver () {
        // this.process.load = true

        let params = {
          limit: 10000000,
          'category_user_id[eq]': '11',
          is_active: 'Aktif',
          // limit: 1000000,
          // par_id: '1'
        }

        await get(`admin/user/data`, { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.driver = res.results.data
            
          }
          // this.process.load = false
        })
      },

      changeOrder() {
        this.order_json = []
        this.varian_arr = []
        // this.order_json = this.order.find(x => x.id === this.form.order_id)
        // this.fetchDetailOrder(this.form.order_id)
        for (let i = 0; i < this.form.bpb_arr.length; i++) {
          this.fetchDetailOrder(this.form.bpb_arr[i])
        }
      },

      async fetchDetailOrder (id) {
        let params = {
          bpb_id: id
        }

        await get('admin/bpb/detail', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            // let data = []
            // res.results.data.detail.map((item) => {
            //   data.push(item)
            // })
            // this.order_json.res.results.data
            // data.map((item) => {
              this.varian_arr.push(res.results.data.data)
            // })

            // this.varian_arr.varian_arr = []
            // this.varian_arr.map((items, index) => {
            //   this.varian_arr[index].varian_arr = []
            //   this.varian_arr[index].detail.map((item) => {
            //     this.varian_arr[index].varian_arr.push({
            //       varian_id: item.detail_varian_id,
            //       varian_name: item.detail_varian_name,
            //       varian_sku: item.detail_varian_sku,
            //       qty_pcs_approve: item.detail_qty_pcs_approved === undefined ? 0 : item.detail_qty_pcs_approved*1,
            //       qty_lusin_approve: item.detail_qty_lusin_approved === undefined ? 0 : item.detail_qty_lusin_approved*1,
            //       qty_dus_approve: item.detail_qty_dus_approved === undefined ? 0 : item.detail_qty_dus_approved*1,
            //       qty_pcs: 0,
            //       qty_lusin: 0,
            //       qty_dus: 0,
                  
            //     })
            //   })
            // })


          }
        })
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate(),
              isBpb = this.form.bpb_arr.length > 0

        this.message.error = isBpb ? '' : 'Silahkan pilih Bpb'
        if (isValid && isBpb) {
          let form = {
            date: this.form.date,
            driver_id: this.form.driver_id,
            note: this.form.note,
            vehicle_id: this.form.vehicle_id,
            bpb_arr: JSON.stringify(this.form.bpb_arr),
          }
          this.process.form = true

          // SAVE TO REST API
          await post(`admin/surat_jalan/add`, {
            data: form
          })
          .then((response) => {
            let res = response.data

            this.process.form = false

            if (res.status === 200) {

              this.$router.push({ path: '/delivery/surat-jalan' })

            } else {
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>

<style >
table {
  border-collapse: collapse;
  width: 100%;
}

/* tr {
  border-bottom: 1px solid #ddd;
} */
</style>